// src/Config/apiConfig.js
const getApiBaseUrl = () => {
    // Check for environment variables first
    if (process.env.REACT_APP_API_URL) {
        return process.env.REACT_APP_API_URL;
    }

    // Check localStorage for runtime configuration
    const storedUrl = localStorage.getItem('apiBaseUrl');
    if (storedUrl) {
        return storedUrl;
    }
    const getProductionUrl = () => {
        const hostname = window.location.hostname;
        if (hostname.includes('-dev.')) return 'https://casinoportalusa-dev.ggl-cloud.com';
        if (hostname.includes('-prod.')) return 'https://casinoportalusa-prod.ggl-cloud.com';
        return 'https://casinoportalusa-sbx.ggl-cloud.com'; // default to sandbox
    };
    // Default URLs based on environment
    return process.env.NODE_ENV === 'production'
        ? getProductionUrl()
        : 'https://localhost:44350';
    // Default URLs based on environment
    // return process.env.NODE_ENV === 'production'
    //     ? 'https://casinoportalusa-sbx.ggl-cloud.com'  // Container environment
    //     //? 'http://localhost:8080'  // Container environment
    //     : 'https://localhost:44350'; // Local IIS development
};

// Set the base URL - can be used to change URL at runtime via console
export const setApiBaseUrl = (url) => {
    if (url) {
        localStorage.setItem('apiBaseUrl', url);
        console.log(`API base URL updated to: ${url}`);
        return true;
    }
    return false;
};

// Get the current base URL
export const API_BASE_URL = getApiBaseUrl();

// Helper to create API endpoints
export const createApiUrl = (endpoint) => {
    return `${API_BASE_URL}/api/${endpoint}`;
};